import '@/assets/scss/styles.scss';
import 'vue-js-modal/dist/styles.css';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import VModal from 'vue-js-modal/dist/index.nocss.js';
import * as filter from './directives/filters';
import AppSelect from '@/components/inputs/AppSelect.vue';
import AppRadioGroup from '@/components/inputs/AppRadioGroup.vue';
import Card from '@/components/card/Card.vue';
import ExpanPanel from '@/components/ExpansionPanel.vue';
import CardSelectItem from '@/components/card/CardSelectItem.vue';
import CardFooter from '@/components/card/CardFooter.vue';
import AppDialog from '@/components/dialogs/AppDialog.vue';
import IconRight from '@/components/icons/IconRight.vue';
import AnimatedNumber from '@/components/AnimatedNumber.vue';
// ※本番環境では /common/js/config.json から読み込みます（dev_simulation/public/config/settings.json を手動でサーバに上げてください）
import { loadServerConfig } from '@/services/config/configLoader';

Vue.config.productionTip = false;
Vue.use(VModal, { dynamic: true });

Vue.filter('toLocaleString', filter.toLocaleString);
Vue.filter('shortenFileName', filter.shortenFileName);

Vue.component('app-select', AppSelect);
Vue.component('app-radio-group', AppRadioGroup);
Vue.component('app-card', Card);
Vue.component('app-expan-panel', ExpanPanel);
Vue.component('app-card-select-item', CardSelectItem);
Vue.component('app-card-footer', CardFooter);
Vue.component('app-dialog', AppDialog);
Vue.component('icon-right', IconRight);
Vue.component('animated-number', AnimatedNumber);

// サーバ設定を読み込んでストアに反映
loadServerConfig().then(config => {
  if (config?.dialog) {
    store.commit('dialog/setConfig', config.dialog);
  }
  mountApp();
}).catch(() => {
  mountApp();
});

function mountApp() {
  new Vue({
    router,
    store,
    vuetify,
    render: (h) => h(App),
  }).$mount('#app');
}
